<template>
  <div>
    <!-- 底价配置-列表 -->
    <baseBreadcrumb :page="$t('message.basePriceConfigurationList')" :menu="$t('message.operationAndMaintenance')" />
    <div class="body">
      <div class="search">
        <div class="left">
          <!-- 商品链接 -->
          <div class="item">
            <el-input v-model="datas.link" :placeholder="$t('message.ProductLink')"></el-input>
          </div>
          <!-- 商品ID-->
          <div class="item">
            <el-input v-model="datas.goods_id" :placeholder="$t('message.goodsID')"></el-input>
          </div>
          <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        </div>
        <div class="rigth">
          <!-- 批量删除 -->
          <el-button class="dark" type="primary" @click="batchDeletion">{{ $t('message.batchDeletion') }}</el-button>
          <!-- 创建商品 -->
          <el-button type="success" @click="createProduct">{{ $t('message.CreateProduct') }}</el-button>
        </div>
      </div>
      <div class="table">
        <ol>
          <li class="flex05">NO</li>
          <li class="flex05">
            <el-checkbox v-model="checked" @change="allChecked"></el-checkbox>
          </li>
          <!-- 商品链接 -->
          <li class="flex2">{{ $t('message.ProductLink') }}</li>
          <!-- 商品链接 -->
          <li class="flex2">{{ $t('message.goodsID') }}</li>
          <!-- 商品图片 -->
          <li>{{ $t('message.productPicture') }}</li>
          <!-- 底价 -->
          <li class="flex3">{{ $t('message.basePrice') }}</li>
          <!-- 操作 -->
          <li>{{ $t('message.operation') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">{{ item.rowNumber }}</li>
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="singleSelection"></el-checkbox>
          </li>
          <!-- 商品链接 -->
          <li class="flex2">
            <p><a :href="item.link" target="_blank" rel="noopener noreferrer" class="a-link">{{ item.link }}</a></p>
          </li>
          <!-- 商品id -->
          <li class="flex2">{{ item.goods_id }}</li>
          <!-- 商品图片 -->
          <li>
            <el-image style="width: 100px; height: 100px" :src="item.pic" :preview-src-list="[item.pic]">
            </el-image>
          </li>
          <!-- 底价 -->
          <li class="flex3">
            <div class="template">
              <div class="row" v-for="(detail, detailIndex) in item.config_price_goods_detail" :key="detailIndex">
                <div class="label">
                  <span v-for="(prop, propIndex) in detail.prop" :key="propIndex">
                    {{ prop.key }}:{{ prop.value }}; </span>
                </div>
                <div class="val">
                  {{ $t('message.basePrice') }}: <span>{{ detail.price }}</span>元
                </div>
              </div>
            </div>
          </li>
          <!-- 操作 -->
          <li>
            <el-button size="mini" class="dark" type="success" @click="goodsPriceConfigDelete([item.id])">{{
              $t('message.delete')
            }}</el-button>
            <!-- 编辑 -->
            <el-button size="mini" type="success" @click="redact(item)">{{ $t('message.redact') }}</el-button>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 新增编辑商品 -->
    <createProduct ref="createProduct" />
  </div>
</template>
<script>
import createProduct from './components/createProduct'
export default {
  components: {
    createProduct,
  },
  data() {
    return {
      datas: {
        link: '',
        goods_id: '',
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
      checked: false,
    };
  },
  created() {
    this.goodsPriceConfigList()
  },
  methods: {
    // 底价配置-列表
    goodsPriceConfigList() {
      this.$api.siteConfiguration.goodsPriceConfigList(this.datas).then((res) => {
        res.data.data.forEach(item => {
          item.checked = false
        })
        this.tableData = res.data.data
        this.total = res.data.total
        console.log(res);
      });
    },
    search() {
      this.datas.page = 1
      this.goodsPriceConfigList();
    },
    // 分页
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.goodsPriceConfigList();
    },
    // 一页条数
    handleCurrentChange(val) {
      this.datas.page = val;
      this.goodsPriceConfigList();
    },
    // 全选
    allChecked() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
    },
    //单选
    singleSelection() {
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },
    //删除
    goodsPriceConfigDelete(ids) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration.goodsPriceConfigDelete({ ids }).then(res => {
            this.$message.success(res.msg);
            this.goodsPriceConfigList();
          });
        })
        .catch(() => { });
    },
    // 创建商品
    createProduct() {
      let datas = {
        link: '',
        goods_id: '',
        pic: '',
        from_platform: '',
        detail_list: [],
      }
      this.$refs.createProduct.acceptData(datas, true)
    },
    //修改商品
    redact(item) {
      let datas = JSON.parse(JSON.stringify(item))
      datas.detail_list = datas.config_price_goods_detail
      this.$refs.createProduct.acceptData(datas, false)
    },
    //批量删除
    batchDeletion() {
      let ids = []
      this.tableData.forEach(item => {
        if (item.checked) {
          ids.push(item.id)
        }
      })
      if (ids == false) return this.$message.error('请选择要操作的列表')
      this.goodsPriceConfigDelete(ids)
    },
  }
}
</script>
<style lang='scss' scoped>
.body {
  .search {
    display: flex;
    justify-content: space-between;

    .left {
      display: flex;

      .item {
        margin-right: 12px;
      }
    }
  }

  .table {
    margin-top: 24px;

    ol {
      height: 50px;
      z-index: 9;
      position: sticky;
      top: 0;
      left: 0;
    }

    ul {
      background-color: #fff;
      padding: 20px 0;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex3 {
      flex: 3;
    }

    .flex2 {
      flex: 2;
    }

    .template {
      width: 100%;

      .row {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;

        .val {
          padding-right: 20px;

          span {
            color: #B4272D;
            font-size: 16px;
            font-weight: 600;
          }
        }

        &:nth-last-child(1) {
          margin-right: 0;
        }

      }
    }
  }
}
</style>